import React, { useState } from "react";
import Slider from "react-slick";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons";
import { ReactComponent as PriceIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as LocationIcon } from "feather-icons/dist/icons/map-pin.svg";

import { ReactComponent as ChevronLeftIcon } from "feather-icons/dist/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "feather-icons/dist/icons/chevron-right.svg";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-16 lg:py-20`;

const HeadingWithControl = tw.div`flex flex-col items-center sm:items-stretch sm:flex-row justify-between`;
const Heading = tw(SectionHeading)``;
const Controls = tw.div`flex items-center`;
const ControlButton = styled(PrimaryButtonBase)`
  ${tw`mt-4 sm:mt-0 first:ml-0 ml-6 rounded-full p-2`}
  svg {
    ${tw`w-6 h-6`}
  }
`;
const PrevButton = tw(ControlButton)``;
const NextButton = tw(ControlButton)``;

const CardSlider = styled(Slider)`
  ${tw`mt-16`}
  .slick-track { 
    ${tw`flex`}
  }
  .slick-slide {
    ${tw`h-auto flex justify-center mb-1`}
  }
`;
const Card = tw.div`h-full flex! flex-col sm:border max-w-sm sm:rounded-tl-4xl sm:rounded-br-5xl relative focus:outline-none`;
const CardImage = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`w-full h-56 sm:h-64 bg-cover bg-center rounded sm:rounded-none sm:rounded-tl-4xl`
]);

const TextInfo = tw.div`py-6 sm:px-10 sm:py-6`;
const TitleReviewContainer = tw.div`flex flex-col sm:flex-row sm:justify-between sm:items-center`;
const Title = tw.h5`text-2xl font-bold`;

const Description = tw.p`text-sm leading-loose mt-2 sm:mt-4`;

const SecondaryInfoContainer = tw.div`flex flex-col sm:flex-row mt-2 sm:mt-4`;
const IconWithText = tw.div`flex items-center mr-6 my-2 sm:my-0`;
const IconContainer = styled.div`
  ${tw`inline-block rounded-full p-2 bg-gray-700 text-gray-100`}
  svg {
    ${tw`w-3 h-3`}
  }
`;
const Text = tw.div`ml-2 text-sm font-semibold text-gray-800`;

const PrimaryButton = tw(PrimaryButtonBase)`mt-auto sm:text-lg rounded-none w-full rounded sm:rounded-none sm:rounded-br-4xl py-3 sm:py-6`;
export default () => {
  // useState is used instead of useRef below because we want to re-render when sliderRef becomes available (not null)
  const [sliderRef, setSliderRef] = useState(null);
  const sliderSettings = {
    arrows: false,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
        }
      },

      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  };

  /* Change this according to your needs */
  const cards = [
    {
      imageSrc: "https://media.istockphoto.com/id/1440202401/pt/foto/two-farmers-in-a-field-examining-soy-crop.jpg?s=612x612&w=0&k=20&c=TGuoVmAdjwDTEXHbipmws96tRXo92levvdP4ambMxiY=",
      title: "Produtores rurais",
      description: "Do pequeno ao grande produtor, ajudamos produtores rurais a encontrar a melhor solução de crédito e emitir CPR de forma simples, rápida e sem burocracia.",
      locationText: "CPR digital",
      pricingText: "Análise de crédito",
    },
    {
      imageSrc: "https://media.istockphoto.com/id/1354927999/pt/foto/man-choosing-compost-soil-in-plastic-bags-in-hypermarket.jpg?s=612x612&w=0&k=20&c=JWOvxrKMGzTGAVX-UxPMlKVtmiTdhytQ6cbXGAhl45E=",
      title: "Revendas agro",
      description: "Analise e emita crédito com segurança. Faça a gestão inteligênte da carteira com monitoramento de garantias e gestão de recebíveis.",
      locationText: "Gestão de carteira",
      pricingText: "Redução de risco",
    },
    {
      imageSrc: "https://media.istockphoto.com/id/836023472/pt/foto/grain-in-corn-field-set-of-storage-tanks-cultivated-agricultural-crops-processing-plant.jpg?s=612x612&w=0&k=20&c=tyRi4Hh0PdAm2CRi4LQ9Efg7QLquB7hYc4XeVQ1ky0U=",
      title: "Agroindústrias",
      description: "Tenha processos claros de recebimento e acompanhamento, conheça melhor seus clientes e reduza os riscos de financiamento. ",
      locationText: "Gestão de carteira",
      pricingText: "Redução de risco",
    },
    {
      imageSrc: "https://media.istockphoto.com/id/1168884223/pt/foto/businessman-walking-in-corn-field-in-early-summer.jpg?s=612x612&w=0&k=20&c=cmBRYMDSb1q9cIhulP6-llcbPL83tjSFyg7SqW3YfmA=",
      title: "Financeiras",
      description: "Acelere suas operações, faça cobranças inteligentes e reduza riscos desnecessários para sua carteira usando garantias de CPR.",
      locationText: "Análise de crédito",
      pricingText: "Redução de risco",
    },
    {
      imageSrc: "https://media.istockphoto.com/id/1261894659/pt/foto/senior-farmer-discussing-work-and-business-with-a-modern-agronomist-in-the-field.jpg?s=612x612&w=0&k=20&c=K3hfp4ziYSatysp6C73tWNepY1rO5HJw2ML7RZaQgo4=",
      title: "Consultores",
      description: "Trabalha no setor agro e quer indicar suas revendas ou produtores rurais? Faça parte do time de consultores do Safraí.",
      locationText: "Rentabilize",
      pricingText: "Indique e ganhe",
    },
  ]

  return (
    <Container>
      <Content>
        <HeadingWithControl>
          <Heading>Para quem é a Safraí</Heading>
          <Controls>
            <PrevButton onClick={sliderRef?.slickPrev}><ChevronLeftIcon/></PrevButton>
            <NextButton onClick={sliderRef?.slickNext}><ChevronRightIcon/></NextButton>
          </Controls>
        </HeadingWithControl>
        <CardSlider ref={setSliderRef} {...sliderSettings}>
          {cards.map((card, index) => (
            <Card key={index}>
              <CardImage imageSrc={card.imageSrc} />
              <TextInfo>
                <TitleReviewContainer>
                  <Title>{card.title}</Title>
                </TitleReviewContainer>
                <SecondaryInfoContainer>
                  <IconWithText>
                    <IconContainer>
                      <LocationIcon />
                    </IconContainer>
                    <Text>{card.locationText}</Text>
                  </IconWithText>
                  <IconWithText>
                    <IconContainer>
                      <PriceIcon />
                    </IconContainer>
                    <Text>{card.pricingText}</Text>
                  </IconWithText>
                </SecondaryInfoContainer>
                <Description>{card.description}</Description>
              </TextInfo>
              <PrimaryButton>Conheça</PrimaryButton>
            </Card>
          ))}
        </CardSlider>
      </Content>
    </Container>
  );
};
